// STYLE TOKENS - Extracted from REFERENCE site (eventflow-224)
// These are EXACT values - DO NOT APPROXIMATE
// Verified via browser inspection and crawled HTML

const TOKENS = {
  // === COLORS (Verified from reference site) ===
  colors: {
    // Section backgrounds
    heroBackground: '#FDF9F3',                  // rgb(253, 249, 243)
    videoBackground: '#FFF8E7',                 // rgb(255, 248, 231)
    countdownBackground: '#FDF9F3',             // rgb(253, 249, 243)  
    registrationBackground: '#FFF8E7',          // rgb(255, 248, 231)
    messagesBackground: '#FAEBD7',              // rgb(250, 235, 215)
    hotelBackground: '#FFF8E7',                 // rgb(255, 248, 231)
    footerBackground: '#2C2418',                // rgb(44, 36, 24) - dark brown
    
    // Input/Card backgrounds
    inputBackground: '#FDF9F3',                 // Cream for inputs
    cardBackground: '#FFFFFF',                  // White for cards
    
    // Text colors
    textBlack: '#1A1A1A',                       // Primary text
    textGrey: '#4A4A4A',                        // Subtitle text  
    textMuted: '#888888',                       // Placeholder, helper text
    textGold: '#D4A853',                        // Gold accent (rgb(212, 168, 83))
    textGoldDark: '#8B6914',                    // Countdown numbers
    textWhite: '#FFFFFF',
    
    // Border colors - IMPORTANT: Reference uses LIGHT GREY, not gold borders
    borderGrey: '#E8E6E3',                      // Light grey for input borders
    borderGold: '#D4AF37',                      // Gold for decorative borders only
    borderLight: '#E8E6E3',
    
    // Button colors
    buttonGold: '#D4A853',                      // Gold button background
    buttonGoldHover: '#C49843',                 // Darker on hover
    
    // Footer colors
    footerText: '#D4A853',                      // Gold text in footer
    footerLinkMuted: '#AAAAAA',
    footerCopyright: '#6B5A4A',
    
    // Required asterisk  
    requiredRed: '#C74747',                     // Red asterisk for required fields
    
    // Tab colors
    tabActive: '#D4A853',                       // Active tab gold background
    tabInactive: 'transparent',                 // Inactive tab background
    
    // Phone mock frame - more subtle copper/rose gold
    phoneMockFrame: '#C9A868',                  // Softer gold frame
  },
  
  // === FONTS ===
  fonts: {
    heading: '"Playfair Display", serif',
    body: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    elegant: '"Cormorant Garamond", serif',
  },
  
  // === FONT SIZES ===
  fontSizes: {
    heroTitle: '48px',           // "Save the Date" - larger than before
    sectionTitle: '28px',        // "Receive Your Invitation", etc.
    subtitle: '14px',            // Uppercase taglines
    bodyText: '15px',
    labelSmall: '12px',          // Section labels
    inputLabel: '14px',
    inputText: '16px',
    buttonText: '16px',
    countdownNumber: '30px',
    countdownLabel: '11px',
    footerText: '14px',
    footerSmall: '11px',
    oscarLabel: '12px',          // "Ask Oscar" label
  },
  
  // === FONT WEIGHTS ===
  fontWeights: {
    normal: '400',
    medium: '500',
    semiBold: '600',
    bold: '700',
  },
  
  // === LETTER SPACING ===
  letterSpacing: {
    wide: '3px',                 // Uppercase labels
    normal: '0.5px',
  },
  
  // === LINE HEIGHTS ===
  lineHeights: {
    tight: '1.1',
    normal: '1.4',
    body: '1.6',
    relaxed: '1.7',
  },
  
  // === BORDER RADIUS ===
  borderRadius: {
    small: '8px',
    medium: '10px',
    large: '12px',
    xl: '16px',
    round: '20px',
    full: '50%',
  },
  
  // === BORDER WIDTHS ===
  borderWidths: {
    thin: '1px',
    medium: '2px',
  },
  
  // === SHADOWS ===
  shadows: {
    card: '0 6px 24px rgba(0, 0, 0, 0.06)',
    cardHover: '0 8px 32px rgba(0, 0, 0, 0.08)',
    countdown: '0 4px 20px rgba(0, 0, 0, 0.06)',
    countdownBox: '0 2px 8px rgba(0, 0, 0, 0.04)',
    button: '0 4px 16px rgba(212, 168, 83, 0.3)',
    phoneMock: '0 20px 60px rgba(0, 0, 0, 0.25), 0 8px 24px rgba(201, 162, 39, 0.2)',
    dateBadge: '0 2px 8px rgba(0, 0, 0, 0.04)',
    oscar: 'drop-shadow(0 4px 12px rgba(0, 0, 0, 0.2))',
    logo: 'drop-shadow(0 4px 12px rgba(212, 168, 83, 0.3))',
    // Hovering effect for cards/banners
    floating: '0 12px 40px rgba(0, 0, 0, 0.12), 0 4px 16px rgba(212, 168, 83, 0.15)',
    floatingHover: '0 16px 48px rgba(0, 0, 0, 0.16), 0 6px 20px rgba(212, 168, 83, 0.2)',
  },
  
  // === BORDERS ===
  borders: {
    // Luxurious gold and pink dust gradient border
    goldPinkGradient: 'linear-gradient(135deg, #D4A853, #E8A4B8, #D4A853, #F5D0A9, #E8A4B8)',
    goldPinkShimmer: 'linear-gradient(90deg, #D4A853, #E8A4B8, #F5D0A9, #E8A4B8, #D4A853)',
  },
  
  // === SPACING ===
  spacing: {
    sectionPaddingY: '40px',
    sectionPaddingX: '24px',
    cardPadding: '24px',
    inputPaddingY: '12px',
    inputPaddingX: '16px',
    buttonPaddingY: '14px',
    gap: '12px',
  },
  
  // === LAYOUT ===
  layout: {
    maxWidth: '520px',
    phoneMockMaxWidth: '360px',
    phoneMockAspectRatio: '9 / 16',
    phoneMockBorderRadius: '28px',
    phoneMockInnerRadius: '22px',
    phoneMockFrameWidth: '6px',
  },
};

export default TOKENS;
